import React, { useEffect, useState } from "react";
import { fetchRecurringSeries } from "./recurringAppointmentApi";

const formatDateTime = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(value || ""));
  if (!match) return String(value || "");
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), Number(match[4]), Number(match[5]));
  return date.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const RecurringSeriesSchedule = ({ isOpen, appointmentId, currentAppointmentId, onClose, onOpenAppointment }) => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [retryKey, setRetryKey] = useState(0);

  useEffect(() => {
    if (!isOpen || !appointmentId) return undefined;
    const controller = new AbortController();
    let live = true;
    setLoading(true);
    setError("");
    fetchRecurringSeries(appointmentId, { signal: controller.signal })
      .then((rows) => {
        if (live) setAppointments(rows);
      })
      .catch((requestError) => {
        if (live && requestError?.name !== "AbortError") {
          setError(requestError?.message || "Unable to load the recurring schedule.");
        }
      })
      .finally(() => {
        if (live) setLoading(false);
      });
    return () => {
      live = false;
      controller.abort();
    };
  }, [appointmentId, isOpen, retryKey]);

  if (!isOpen) return null;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 10010, background: "rgba(0,0,0,0.68)", padding: 10, boxSizing: "border-box", display: "grid", placeItems: "center" }} onMouseDown={onClose}>
      <div role="dialog" aria-modal="true" aria-labelledby="recurring-series-title" onMouseDown={(event) => event.stopPropagation()} style={{ width: "100%", maxWidth: 680, maxHeight: "calc(100vh - 24px)", overflowY: "auto", border: "6px solid #000", borderRadius: 14, background: "#E8E2DA", color: "black", padding: 12, boxSizing: "border-box" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <h2 id="recurring-series-title" style={{ margin: 0, fontSize: 21 }}>FULL RECURRING SCHEDULE</h2>
          <button type="button" onClick={onClose} style={{ minWidth: 86, minHeight: 44, border: "3px solid #000", borderRadius: 10, background: "white", fontWeight: 900, cursor: "pointer" }}>CLOSE NOW</button>
        </div>
        {loading ? <div role="status" style={{ padding: 18, textAlign: "center", fontWeight: 900 }}>LOADING SCHEDULE...</div> : null}
        {!loading && error ? (
          <div role="alert" style={{ border: "3px solid #000", background: "#fee2e2", padding: 12, fontWeight: 900 }}>
            <div>{error}</div>
            <button type="button" onClick={() => setRetryKey((value) => value + 1)} style={{ marginTop: 10, minHeight: 44, padding: "7px 16px", border: "3px solid #000", background: "white", fontWeight: 900, cursor: "pointer" }}>RETRY</button>
          </div>
        ) : null}
        {!loading && !error && appointments.length === 0 ? (
          <div style={{ padding: 18, textAlign: "center", fontWeight: 900 }}>No saved appointments remain in this series.</div>
        ) : null}
        {!loading && !error ? appointments.map((appointment) => {
          const current = String(appointment.id) === String(currentAppointmentId);
          return (
            <button
              key={appointment.id}
              type="button"
              onClick={() => onOpenAppointment(appointment)}
              style={{
                display: "block",
                width: "100%",
                minHeight: 58,
                marginBottom: 8,
                padding: "10px 12px",
                border: current ? "4px solid #E8761D" : "3px solid #000",
                borderRadius: 10,
                background: appointment.job_type_color || "white",
                color: "black",
                textAlign: "left",
                cursor: "pointer",
                boxSizing: "border-box",
              }}
            >
              <div style={{ fontWeight: 900 }}>{formatDateTime(appointment.start_time)}</div>
              <div style={{ fontWeight: 800 }}>{String(appointment.customer_name || appointment.title || "Appointment")}</div>
              {current ? <div style={{ fontSize: 12, fontWeight: 900 }}>CURRENT APPOINTMENT</div> : null}
            </button>
          );
        }) : null}
      </div>
    </div>
  );
};

export default RecurringSeriesSchedule;
